import xor from 'lodash/xor';
import { BROWSE_KNOWLEDGE, type BrowseKnowledgeAction } from '../../actions/browse-knowledge';
import {
	BROWSE_KNOWLEDGE_FAILURE,
	type BrowseKnowledgeFailureAction,
} from '../../actions/browse-knowledge-failure';
import {
	BROWSE_KNOWLEDGE_SUCCESS,
	type BrowseKnowledgeSuccessAction,
} from '../../actions/browse-knowledge-success';
import { CLEAR_BROWSE, type ClearBrowseAction } from '../../actions/clear-browse';
import {
	UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS,
	type UpdateCategoriesForArticleSuccessAction,
} from '../../actions/update-categories-for-article-success';
import type { BrowseState } from './types';

type Action =
	| BrowseKnowledgeAction
	| BrowseKnowledgeSuccessAction
	| BrowseKnowledgeFailureAction
	| ClearBrowseAction
	| UpdateCategoriesForArticleSuccessAction;

// @ts-expect-error - TS2322 - Type '{ limit: number; }' is not assignable to type 'BrowseState'.
export const defaultState: BrowseState = {
	limit: 20,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: BrowseState = defaultState, action: Action): BrowseState => {
	switch (action.type) {
		case UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS: {
			const { categoryIds, previousCategoryIds } = action.payload;
			if (categoryIds) {
				const newState = {
					...state,
				};

				const categoryIdsNeededCacheClear = xor(categoryIds, previousCategoryIds);

				categoryIdsNeededCacheClear.forEach((categoryId) => {
					if (newState[categoryId]) {
						newState[categoryId].shouldClearCacheOnNextFetch = true;
					}
				});

				return newState;
			}

			return state;
		}

		case CLEAR_BROWSE: {
			const newState = {
				...state,
			};

			delete newState[action.payload];

			return newState;
		}

		case BROWSE_KNOWLEDGE:
			if (
				state[action.payload.id] &&
				state[action.payload.id].pages[`${action.payload.page}`] &&
				// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'string[] | GenericError'.
				state[action.payload.id].pages[`${action.payload.page}`].error
			) {
				const newState = {
					...state,
					loading: true,
				};

				// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ loading: boolean; limit: number; }'.
				delete newState[action.payload.id].pages[`${action.payload.page}`];

				// @ts-expect-error - TS2322 - Type '{ loading: boolean; limit: number; }' is not assignable to type 'BrowseState'.
				return newState;
			}

			if (state[action.payload.id] && state[action.payload.id].shouldClearCacheOnNextFetch) {
				const newState = {
					...state,
					loading: true,
					[action.payload.id]: {
						...state[action.payload.id],
						shouldClearCacheOnNextFetch: false,
						pages: {},
					},
				};

				// @ts-expect-error - TS2322 - Type '{ [x: string]: boolean | BrowseCategoryState | { shouldClearCacheOnNextFetch: boolean; pages: {}; totalSize: number; nextCursor?: string | undefined; prevCursor?: string | undefined; previousPagePath?: string | undefined; categoriesSupported: boolean; }; loading: boolean; limit: number; }' is not assignable to type 'BrowseState'.
				return newState;
			}

			// @ts-expect-error - TS2322 - Type '{ loading: true; limit: number; }' is not assignable to type 'BrowseState'.
			return { ...state, loading: true };

		case BROWSE_KNOWLEDGE_FAILURE:
			// eslint-disable-next-line no-case-declarations
			const newFailureState = {
				...state,
				loading: false,
				[action.payload.id]: {
					pages: {
						[`${action.payload.page}`]: {
							error: action.payload.error,
						},
					},
				},
			} as const;
			// @ts-expect-error - TS2322 - Type '{ readonly [x: string]: false | BrowseCategoryState | { readonly pages: { readonly [x: string]: { readonly error: GenericErrorObject; }; }; }; readonly loading: false; readonly limit: number; }' is not assignable to type 'BrowseState'.
			return newFailureState;

		case BROWSE_KNOWLEDGE_SUCCESS:
			// eslint-disable-next-line no-case-declarations
			const newSuccessState = {
				...state,
				loading: false,
				[action.payload.id]: {
					totalSize: action.payload.totalSize,
					categoriesSupported: action.payload.categoriesSupported,
					pages: {
						...(state[action.payload.id] ? state[action.payload.id].pages : {}),
						[`${action.payload.page}`]: action.payload.results.map((article) => article.id),
					},
					...{
						nextCursor: action.payload.nextCursor || '',
						prevCursor: action.payload.prevCursor || '',
					},
				},
			} as const;
			// @ts-expect-error - TS2322 - Type '{ readonly [x: string]: false | BrowseCategoryState | { readonly nextCursor: string; readonly prevCursor: string; readonly totalSize: number; readonly categoriesSupported: boolean; readonly pages: { ...; }; }; readonly loading: false; readonly limit: number; }' is not assignable to type 'BrowseState'.
			return newSuccessState;
		default: {
			return state;
		}
	}
};
